import { render, staticRenderFns } from "./ProofreadLearningMapUnits.vue?vue&type=template&id=063b5bb6&scoped=true&lang=pug&"
import script from "./ProofreadLearningMapUnits.vue?vue&type=script&lang=ts&"
export * from "./ProofreadLearningMapUnits.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadLearningMapUnits.vue?vue&type=style&index=0&id=063b5bb6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b5bb6",
  null
  
)

export default component.exports